import React, { useState, useEffect } from 'react'
import Pagination from 'rc-pagination'
import moment from 'moment'
import ReportTable from './components/reportTable'
import { getUsersMonthReport } from '../../../api/cn'
import styles from './styles.scss'

const RegisterForm = ({ cns, months, schools, clazzes }) => {

  const columns = [
    { title: '用户名', dataIndex: 'username', key: 'username' },
    { title: '手机号', dataIndex: 'phone', key: 'phone' },
    { title: '注册时间', dataIndex: 'createTime', key: 'createTime' },
    // { title: '注册关联渠道号', dataIndex: 'code', key: 'code' },
    // { title: '对应渠道商名称', dataIndex: 'name', key: 'name' },
    // { title: '加入学校', dataIndex: 'campus', key: 'campus' },
    // { title: '加入班级', dataIndex: 'class', key: 'class' }
  ]

  const [month, setMonth] = useState(months[0])
  const [cn, setCN] = useState(cns[0])
  // const [school, setSchool] = useState('')
  // const [clazz, setClazz] = useState('')
  const [userInfo, setUserInfo] = useState('')
  const [reportData, setReportData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [totalElement, setTotalElement] = useState(0)

  useEffect(() => {
    handleSearch()
  }, [month, cn, currentPage])

  const handleMonthChange = e => {
    const item = e.target.options[e.target.options.selectedIndex]
    setMonth({ label: item.label, value: item.value })
  }

  const handleCNChange = e => {
    const item = e.target.options[e.target.options.selectedIndex]
    setCN({ label: item.label, value: item.value })
    setCurrentPage(1)
  }

  // const handleSchoolChange = e => {
  //   setSchool(e.target.value)
  // }

  // const handleClazzChange = e => {
  //   setClazz(e.target.value)
  // }

  const handleUserInfoChange = e => {
    setUserInfo(e.target.value)
  }

  const handleSearch = () => {
    const params = {
      // month: month.value,
      cn: cn.value,
      page_size: pageSize,
      page: currentPage
    }

    if (!!userInfo) {
      params.phone = userInfo
    }

    getUsersMonthReport(params, { quiet: true }).then(res => {
      if (!!res && !!res.users) {
        const data = res.users.data.map(item => ({
          username: item.name,
          phone: item.phone,
          createTime: !!item.created_at ? moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') : ''
        }))
        setReportData(data)
        setTotalElement(res.users.total)
      }
    })
  }

  const handlePageChange = e => {
    setCurrentPage(e)
  }

  const handleExport = () => {
    console.log(11111);
  }

  return (
    <div className={styles.forms}>
      <div className={styles.filter}>
        {/*<select value={school} onChange={handleSchoolChange}>
          {
            schools.map(item => (
              <option key={item.value} value={item.value}>{item.label}</option>
            ))
          }
        </select>
        <select value={clazz} onChange={handleClazzChange}>
          {
            clazzes.map(item => (
              <option key={item.value} value={item.value}>{item.label}</option>
            ))
          }
        </select>*/}
        {/*<select value={month.value} onChange={handleMonthChange}>
          {
            months.map(item => (
              <option key={item.value} value={item.value}>{item.label}</option>
            ))
          }
        </select>*/}
        <select value={cn.value} onChange={handleCNChange}>
          {
            cns.map(item => (
              <option key={item.value} value={item.value}>{item.label}</option>
            ))
          }
        </select>
        <input value={userInfo} placeholder='手机号' onChange={handleUserInfoChange} />
        {/*<input value={canalInfo} placeholder='渠道号' onChange={handleCanalInfoChange} />*/}
        <button className={styles.changeBtn} onClick={() => {
          setCurrentPage(1)
          handleSearch()
        }}>搜索</button>
      </div>
      <div className={styles.total}>
        <div className={styles.summary}>
          <span>累计注册数：{totalElement}</span>
        </div>
        {/*<button className={styles.changeBtn} onClick={handleExport}>导出</button>*/}
      </div>
      <ReportTable columns={columns} dataSource={reportData} />
      <div className={styles.pager}>
        <Pagination
          current={currentPage}
          defaultPageSize={pageSize}
          total={totalElement}
          onChange={handlePageChange}
        ></Pagination>
      </div>
    </div>
  )
}

export default RegisterForm
